export default __webpack_public_path__ + "static/media/team.18bbe5d4.jpeg";